<!--
 * @Author: cgh
 * @Date: 2022-08-02 15:32:24
 * @LastEditors: cgh
 * @LastEditTime: 2022-08-31 09:50:23
 * @Description: 评估仪器管理（查看详情）
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-60 o-dialog--xl-50"
    title="查看信息"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :inline="true"
        label-position="right"
        label-width="150px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="设备名称"
              prop="sbmc"
            >
              <span
                class="c-form__read"
              >
                {{ fd.sbmc || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="设备编号"
              prop="sbbh"
            >
              <span
                class="c-form__read"
              >
                {{ fd.sbbh || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="检定/校准证件编号"
              prop="jyzjbh"
            >
              <span
                class="c-form__read"
              >
                {{ fd.jyzjbh || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="有效期"
              prop="yxq"
            >
              <span
                class="c-form__read"
              >
                {{ fd.yxq | date("yyyy-MM-dd") }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="是否启用"
              prop="sfqy"
            >
              <span
                class="c-form__read"
              >
                {{ fd.sfqy === 'Y' ? '启用' : '停用' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="添加时间"
              prop="cjsj"
            >
              <span
                class="c-form__read"
              >
                {{ fd.cjsj | date("yyyy-MM-dd HH:mm:ss") }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { pgyqManageService } from './pgyq.service.js';
export default {
  name: 'DetailsDialog',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示

      loading: false, // 页面是否加载
      /* 表单参数 Start */
      fd: {
        id: null,
        sbmc: null, // 设备名称
        sbbh: null, // 设备编号
        jyzjbh: null,
        yxq: null,
        sfqy: null,
        cjsj: null
      }
      /* 表单参数 End */
      /* 表单校验规则 Start */
    };
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * 初始化数据
     */
    init (_id) {
      this.loading = true;
      pgyqManageService.getDetail(_id)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);
        })
        .catch(err => {
          console.error('获取评估仪器信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }

  },
  created () {
    this.init(this.dlParams.id);
  }
};

</script>
